/*
Node.js util module overview

The util module in Node.js provides various utility functions that are helpful for developers. Here’s an overview of the most commonly used utilities and their purposes:

1. Type Checking & Equality
util.types – Object containing advanced type-checking helpers:
isArrayBuffer, isDate, isRegExp, isMap, isSet, isTypedArray, isProxy, etc.
util.isDeepStrictEqual(val1, val2)
Deep strict equality check for objects, arrays, primitives, nested structures.

2. Formatting & Inspection
util.format(format, ...args)
Like printf. Supports %s, %d, %j.
util.formatWithOptions(inspectOptions, format, ...args)
Same as format, but allows custom inspect options.
util.inspect(object[, options])
Returns a string representation of any object. Options:
showHidden, depth, colors, customInspect, maxArrayLength, etc.
util.inspect.custom (Symbol)
Used to define a custom inspection method for objects. Example:
const util = require('util');
class Foo {
  [util.inspect.custom]() { return 'FooCustom'; }
}
console.log(util.inspect(new Foo())); // "FooCustom"

3. Callback / Promise Utilities
util.promisify(fn)
Converts a callback-style function into a Promise-based function.
util.callbackify(fn)
Converts a Promise-based function into a callback-style function.

4. Deprecation / Debugging
util.deprecate(fn, msg[, code])
Wrap a function so that calling it prints a deprecation warning.
util.debuglog(section)
Returns a function that logs messages to stderr if NODE_DEBUG includes the section.
const debug = util.debuglog('myapp');
debug('This will print if NODE_DEBUG=myapp');

5. Inheritance / Classes
util.inherits(constructor, superConstructor)
Legacy: sets up prototype inheritance (mostly replaced by class extends in modern JS).
util.promisify.custom (Symbol)
For defining a custom implementation of util.promisify for a function.
util.types (again, has things like isAsyncFunction, isGeneratorFunction, isNativeError)

6. Text Encoding / Decoding
util.TextEncoder
Converts strings → Uint8Array.
util.TextDecoder
Converts Uint8Array → strings.

7. BigInt & Array Helpers
util.getSystemErrorName(err)
Returns the string name of a system error code (like ENOENT).
util.callbackify.custom (Symbol)
Define custom behavior for callbackify.

The most commonly used utilities are:
isDeepStrictEqual – deep object comparison
promisify / callbackify – async handling
inspect / format – debugging & logging
types – advanced type checks
deprecate / debuglog – warnings & logging
Everything else is niche, usually for library authors or very specific Node features.
*/

import util from 'node:util';

// Polyfill for browsers that do not have util.isDeepStrictEqual
export const isDeepStrictEqual =
  util.isDeepStrictEqual === undefined
    ? (a, b) => JSON.stringify(a) === JSON.stringify(b)
    : util.isDeepStrictEqual;
